import { render, staticRenderFns } from "./EarnPoints.vue?vue&type=template&id=81fcaa0a&scoped=true&"
import script from "./EarnPoints.vue?vue&type=script&lang=js&"
export * from "./EarnPoints.vue?vue&type=script&lang=js&"
import style0 from "./EarnPoints.vue?vue&type=style&index=0&id=81fcaa0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81fcaa0a",
  null
  
)

export default component.exports